import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@chakra-ui/react';

import { TextSemiBold, TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';
import HeaderMobile from 'Component/header-mobile';
import { alertSuccess } from 'Const/reset-password';
import useIsMobile from 'Hook/useIsMobile';

import { useResetPasswordState } from 'View/reset-password/state';

import styles from './styles.module.css';

const Success = () => {
  const isMobile = useIsMobile;
  const { state } = useResetPasswordState();
  const navigate = useNavigate();

  const handleBackButton = () => navigate('/login');

  return (
    <Box className={styles['request-sent__container']}>
      <Condition statement={isMobile}>
        <HeaderMobile type="header-back" title="Ganti Password" onClick={handleBackButton} />
      </Condition>
      <Box className={styles['section__content']}>
        <TextSemiBold className={styles['page__title']}>{alertSuccess.title}</TextSemiBold>
        <TextRegular className={styles['feedback__text']}>{state?.successMessage || alertSuccess.description}</TextRegular>
        <Button className={styles['action__button']} width="100%" height="42px" type="button" onClick={handleBackButton}>
          {alertSuccess.action}
        </Button>
      </Box>
    </Box>
  );
};

export default Success;
